const quantity = {
  init: function () {
    const containers = document.getElementsByClassName('js-quantity');
    if (containers) {
      this.bind(containers);
    }
  },
  
  bind: function (containers) {

    Array.prototype.forEach.call(containers, (container, index) => {
      const input = container.getElementsByTagName('input')[0];
      const min = input.getAttribute('min');
      const max = input.getAttribute('max');
      const btnUp = container.querySelector('.quantity__up');
      const btnDown = container.querySelector('.quantity__down');

      btnUp.addEventListener('click', () => {
        this.increment(input, min, max);
      });

      btnDown.addEventListener('click', () => {
        this.decrement(input, min, max);
      });
      
    });

  },

  bindContainer: function (container) {

    const input = container.getElementsByTagName('input')[0];
    const min = input.getAttribute('min');
    const max = input.getAttribute('max');
    const btnUp = container.querySelector('.quantity__up');
    const btnDown = container.querySelector('.quantity__down');
    btnUp.addEventListener('click', () => {
      this.increment(input, min, max);
    });

    btnDown.addEventListener('click', () => {
      this.decrement(input, min, max);
    });

  },

  increment: function (input, min, max) {
    const oldValue = parseFloat(input.value);

    if (oldValue >= max) {
      const newVal = oldValue;
      input.value = newVal;
    } else {
      const newVal = oldValue + 1;
      input.setAttribute('value', newVal);
      input.value = newVal;
    }
  },

  decrement: function (input, min, max) {
    const oldValue = parseFloat(input.value);
    
    if (oldValue <= min) {
      const newVal = oldValue;
      input.value = newVal;
    } else {
      const newVal = oldValue - 1;
      input.setAttribute('value', newVal);
      input.value = newVal;
    }
  }
}

quantity.initialize = () => {

  quantity.init();
};

module.exports = quantity;
